import { read, utils } from 'xlsx';

export function formatLabel(label) {
  return label?.split('_')?.reduce((acc, value, index) => {
    if (!acc) return value.charAt(0).toUpperCase() + value.substring(1);

    return acc + ' ' + value.charAt(0).toUpperCase() + value.substring(1);
  }, '');
}

export const downloadFile = async (data, filename = '') => {
  const fileType = 'text/csv';
  const file = new Blob([data], {type: fileType});
  const element = document.createElement("a");

  element.href = URL.createObjectURL(file);
  if (filename) {
    element.download = filename + ` (CBP).csv`;
  } else {
    element.download = "SP_Converter_Download-" + new Date().getTime() + `.csv`;
  }
  
  document.body.appendChild(element); 

  element.click();

  document.body.removeChild(element);
  URL.revokeObjectURL(file);
}

export const generateConcatenatedFile = async (fileOutputHistory, outputFilename = '') => {
  const fileOutput = [];
  const headers = [];

  fileOutputHistory?.forEach((sessionRecord, sessionRecordIndex, sessionArr) => {
    const records = JSON.parse(sessionRecord.content.data);

    if (sessionRecordIndex === 0) {
      headers.push(...Object.keys(records[0]));

      fileOutput.push(headers?.map(h => `"${h}"`)?.join(','));
    }

    const prevSessionRecord = sessionRecordIndex > 0 ? JSON.parse(sessionArr[sessionRecordIndex - 1].content.data) : undefined;

    records?.forEach((record, index) => {
      if (headers.length > Object.keys(record)?.length) return;
      if (index === 1 && fileOutput?.length > 1 && prevSessionRecord && headers.findIndex(h => prevSessionRecord[prevSessionRecord.length - 1][h] !== record[h]) !== -1) return;

      const row = headers?.map(h => {
        const r = record[h] ?? '';
        return r ? `"${r?.toString()?.replaceAll(/"{1,}/g, '""')}"` : null;
      })?.join(',');

      if (fileOutput?.findIndex(d => d === row) !== -1) return;

      fileOutput.push(row);
    });
  });

  const fileData = fileOutput.join('\n');
  await downloadFile(fileData, outputFilename);
}

export async function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      switch (file.type) {
        case 'text/csv':
        case 'application/pdf':
          resolve(e.target.result.replace(/^data:(.*,)?/, ''));

          break;
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        case 'application/vnd.oasis.opendocument.spreadsheet': 
        case 'application/vnd.google-apps.spreadsheet': 
        case 'application/vnd.ms-excel':
          const data = atob(e.target.result.split(',')[1]);
          const workbookData = read(data, { type: "binary" });

          const parsedData = workbookData.SheetNames.map(name => {
            const ws = workbookData.Sheets[name];
            return utils.sheet_to_csv(ws);
          });

          resolve(btoa(encodeURIComponent(parsedData?.join("\n\n"))));
          break;
        default: 
          resolve(e.target.result.replace(/^data:(.*,)?/, ''));
      }
      
    };
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
}